import MmcNotificationAction from "@app/enum/MmcNotificationAction";
import NotificationSettingValue from "@app/types/notifications/NotificationSetting";

const switchOffNotificationSetting = (
  settings: NotificationSettingValue,
  action: MmcNotificationAction
): NotificationSettingValue => {
  if (action === MmcNotificationAction.MENTION) {
    return { ...settings, mentions: false, teamMentions: false };
  }
  if (
    [
      MmcNotificationAction.COMPANY_GROUP_SHARED,
      MmcNotificationAction.DEAL_GROUP_SHARED,
      MmcNotificationAction.PEOPLE_GROUP_SHARED,
    ].includes(action)
  ) {
    return { ...settings, sharing: { ...settings.sharing, groups: false } };
  }
  if (
    [
      MmcNotificationAction.COMPANY_ROUTE_SHARED,
      MmcNotificationAction.PEOPLE_ROUTE_SHARED,
      MmcNotificationAction.UNIFIED_ROUTE_SHARED,
    ].includes(action)
  ) {
    return { ...settings, sharing: { ...settings.sharing, routes: false } };
  }
  if (MmcNotificationAction.OWNERSHIP_CHANGED === action) {
    return { ...settings, sharing: { ...settings.sharing, ownership: false } };
  }
  if (MmcNotificationAction.DEALS_MARKED_LOST === action) {
    return {
      ...settings,
      recordUpdates: {
        ...settings.recordUpdates,
        owned: {
          ...settings.recordUpdates.owned,
          dealStages: { ...settings.recordUpdates.owned.dealStages, closedLost: false },
        },
        shared: {
          ...settings.recordUpdates.shared,
          dealStages: { ...settings.recordUpdates.shared.dealStages, closedLost: false },
        },
      },
    };
  }
  if (MmcNotificationAction.DEALS_MARKED_WON === action) {
    return {
      ...settings,
      recordUpdates: {
        ...settings.recordUpdates,
        owned: {
          ...settings.recordUpdates.owned,
          dealStages: { ...settings.recordUpdates.owned.dealStages, closedWon: false },
        },
        shared: {
          ...settings.recordUpdates.shared,
          dealStages: { ...settings.recordUpdates.shared.dealStages, closedWon: false },
        },
      },
    };
  }
  if (MmcNotificationAction.DEALS_STAGE_CHANGED === action) {
    return {
      ...settings,
      recordUpdates: {
        ...settings.recordUpdates,
        owned: {
          ...settings.recordUpdates.owned,
          dealStages: { ...settings.recordUpdates.owned.dealStages, openStage: false },
        },
        shared: {
          ...settings.recordUpdates.shared,
          dealStages: { ...settings.recordUpdates.shared.dealStages, openStage: false },
        },
      },
    };
  }
  if (MmcNotificationAction.OUT_OF_CADENCE === action) {
    return {
      ...settings,
      recordUpdates: {
        ...settings.recordUpdates,
        owned: {
          ...settings.recordUpdates.owned,
          outOfCadence: false,
        },
        shared: {
          ...settings.recordUpdates.shared,
          outOfCadence: false,
        },
      },
    };
  }
  if (MmcNotificationAction.OVERDUE_ACTIVITIES === action) {
    return {
      ...settings,
      recordUpdates: {
        ...settings.recordUpdates,
        owned: {
          ...settings.recordUpdates.owned,
          overdueActivities: false,
        },
        shared: {
          ...settings.recordUpdates.shared,
          overdueActivities: false,
        },
      },
    };
  }
  if (MmcNotificationAction.DEALS_ROTTING === action) {
    return {
      ...settings,
      recordUpdates: {
        ...settings.recordUpdates,
        owned: {
          ...settings.recordUpdates.owned,
          rottedDeals: false,
        },
        shared: {
          ...settings.recordUpdates.shared,
          rottedDeals: false,
        },
      },
    };
  }
  if (MmcNotificationAction.ACTIVITY_LOGGED === action) {
    return {
      ...settings,
      notesAndActivities: {
        ...settings.notesAndActivities,
        ownedRecord: {
          activityOnOwnedRecord: false,
          enabled: false,
          noteOnOwnedRecord: false,
        },
      },
    };
  }
  if (MmcNotificationAction.NOTE_ADDED === action) {
    return {
      ...settings,
      notesAndActivities: {
        ...settings.notesAndActivities,
        activityOwned: {
          activityCompleted: false,
          activityTimeChanged: false,
          enabled: false,
        },
      },
    };
  }
  if (MmcNotificationAction.ACTIVITY_ASSIGNED === action) {
    return {
      ...settings,
      notesAndActivities: {
        ...settings.notesAndActivities,
        activityAssigned: {
          activityCompleted: false,
          activityTimeChanged: false,
          enabled: false,
          incompleteActivityEndReminder: false,
          noteOnAssignedActivity: false,
        },
      },
      sharing: {
        ...settings.sharing,
        activityAssigned: false,
      },
    };
  }
  if (
    [MmcNotificationAction.AUTO_TRACKED_TRIPS, MmcNotificationAction.UNCLASSIFIED_TRIPS].includes(
      action
    )
  ) {
    return {
      ...settings,
      mileageTracking: {
        ...settings.mileageTracking,
        enabled: false,
        flaggedTrips: false,
        weeklyClassificationReminder: false,
        weeklyTrackedTrips: false,
      },
    };
  }
  if (
    [
      MmcNotificationAction.COACHING_NOTE_CREATED,
      MmcNotificationAction.COACHING_NOTE_REPLIED,
    ].includes(action)
  ) {
    return {
      ...settings,
      coachingNotes: {
        ...settings.coachingNotes,
        assignedToMe: false,
        assignedToTeamMembers: false,
        enabled: false,
        mentions: false,
      },
    };
  }
  if (action === MmcNotificationAction.COACHING_TASK_OVERDUE) {
    return {
      ...settings,
      coachingTasks: { ...settings.coachingTasks, overdueAssignedByMe: false },
    };
  }
  if (
    [
      MmcNotificationAction.COACHING_TASK_ASSIGNED,
      MmcNotificationAction.COACHING_TASK_COMPLETED,
      MmcNotificationAction.COACHING_TASK_CREATED,
      MmcNotificationAction.COACHING_TASK_MENTIONED,
    ].includes(action)
  ) {
    return {
      ...settings,
      coachingTasks: {
        ...settings.coachingTasks,
        assignedToMe: false,
        assignedToTeamMembers: false,
        enabled: false,
        mentions: false,
        taskCompleted: false,
      },
    };
  }
  return settings;
};

export default switchOffNotificationSetting;
